<div class="tabs" [ngClass]="design">
    <ng-container *ngFor="let tab of tabs; index as i">
        <div class="tabs__tab" [ngClass]="{'tabs__tab--active': tab.selected}" (click)="changeSelected(i)" *ngIf="tab.show !== false">
            {{ tab.title }} 
            <app-badge *ngIf="tab.notifications && !design?.includes('tabs--pills')">{{ tab.notifications }}</app-badge>
            <app-icons *ngIf="design?.includes('tabs--vertical')" design="icon-arrow-right"></app-icons>
        </div>
    </ng-container>
</div>
